module.exports = {
  Individual: '个',
  AreYouWantToCopy: '请确认是否复制？',
  Hint: '提示',
  Confirm: '确定',
  Cancel: '取消',
  BiDomainName: 'BI域名',
  FillBiDomainName: '请填写BI域名'
}
